<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ch2"> </p>
<p class="CT"><span epub:type="pagebreak" id="pg_24" title="24"><span href="#/xhtml/contents#c_ch2" title="Link target outside of Sample">1954</span></span></p>
<p class="CO">There were no Hugo Awards in 1954.</p>
<p class="TX">The 1954 International Fantasy Awards considered <span class="ePub-I">The Demolished Man</span> and Theodore Sturgeon’s <span class="ePub-I">More Than Human</span>. <span class="ePub-I">More Than Human</span> should definitely have been a Hugo nominee if it was eligible. It’s another enduring classic, Sturgeon at his best and on his favorite topic.</p>
<p class="H1"><span class="ePub-B">C</span><span class="ePub_SC_B">OMMENTS ON</span> <span class="ePub-B">1954</span></p>
<p class="H2F">6. R<span class="ePub-SC">ICH</span> H<span class="ePub-SC">ORTON</span></p>
<p class="TNI">The list for the awards that might have been, in 1954, is <span class="ePub-SC">REALLY REALLY</span> impressive, as the Retro Hugo nominees from a few years ago show: <span class="ePub-I">The Caves of Steel,</span> by Isaac Asimov; <span class="ePub-I">Fahrenheit 451,</span> by Ray Bradbury; <span class="ePub-I">Childhood’s End,</span> by Arthur C. Clarke; <span class="ePub-I">Mission of Gravity,</span> by Hal Clement; and <span class="ePub-I">More Than Human,</span> by Theodore Sturgeon. (Other potential choices, not as good but still quite good: Robert A. Heinlein’s <span class="ePub-I">Revolt in 2100</span> and <span class="ePub-I">Starman Jones,</span> Fritz Leiber’s <span class="ePub-I">The Sinful Ones</span> and <span class="ePub-I">The Green Millennium,</span> John Wyndham’s <span class="ePub-I">The Kraken Wakes</span> aka <span class="ePub-I">Out of the Deeps,</span> Ward Moore’s <span class="ePub-I">Bring the Jubilee,</span> and Wilmar Shiras’s <span class="ePub-I">Children of the Atom.</span>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?304c33b6